import { useMemo, useState } from 'react'
import { DEFAULT_PAGE_SIZE } from '../../../common/constants'
import { useSearchExternalUsersQuery } from '../../../store/externalUser/externalUser'

export const useContactSearch = ({ accountId, ownerId }: { accountId: string; ownerId?: string }) => {
  const [search, setSearch] = useState<string>()

  // An emptied input maps to the same arg as the initial load, so clearing the search serves the
  // cached first page instead of firing an empty-term request.
  const query = useSearchExternalUsersQuery({
    accountId,
    term: search?.trim() || undefined,
    ownerId,
    orderBy: 'lastName',
    pageRequest: { page: 0, size: DEFAULT_PAGE_SIZE },
  })

  const contacts = useMemo(() => query.data?.data ?? [], [query.data])

  return { ...query, data: contacts, search, setSearch }
}
